// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"PostTags-module--tag-container--2e_Q9"};